<div class="table-container mat-elevation-z8">
  <table mat-table [dataSource]="countries" matSort matSortDisableClear
         matSortActive="cases" matSortDirection="desc">

    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> #</th>
      <td mat-cell *matCellDef="let element; let i = index;">
        {{i + 1}}
      </td>
    </ng-container>

    <!-- Country Column -->
    <ng-container matColumnDef="flag">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Flag.</th>
      <td mat-cell *matCellDef="let element">
        <img [src]="element.countryInfo.flag" alt="flag">
      </td>
    </ng-container>

    <!-- Country Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Country</th>
      <td mat-cell *matCellDef="let element"> {{element.country}} </td>
    </ng-container>

    <!-- Cases Column -->
    <ng-container matColumnDef="cases">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Cases</th>
      <td mat-cell *matCellDef="let element"> {{element.cases | number}} </td>
    </ng-container>

    <!-- Deaths Column -->
    <ng-container matColumnDef="deaths">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Deaths</th>
      <td mat-cell *matCellDef="let element"> {{element.deaths | number}} </td>
    </ng-container>

    <!-- Mortality Rate Column -->
    <ng-container matColumnDef="mortalityRate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Confirmed Cases Mortality Rate"> Mortality Rate</th>
      <td mat-cell *matCellDef="let element">
        <span style="margin-left: 15px">{{((element.deaths / element.cases) | percent: "1.2")}}</span>
      </td>
    </ng-container>

    <!-- Deaths Per Million Column -->
    <ng-container matColumnDef="deathsPerOneMillion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Deaths Per Million</th>
      <td mat-cell *matCellDef="let element">
        <span style="margin-left: 15px">{{element.deathsPerOneMillion | number}}</span>
      </td>
    </ng-container>

    <!-- Tests Per Million Column -->
    <ng-container matColumnDef="testsPerOneMillion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Tests Per Million</th>
      <td mat-cell *matCellDef="let element"> {{element.testsPerOneMillion | number}} </td>
    </ng-container>

    <!-- Cases Per Million Column -->
    <ng-container matColumnDef="casesPerMillion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Cases Per Million</th>
      <td mat-cell *matCellDef="let element"> {{element.casesPerOneMillion | number}} </td>
    </ng-container>

     <!-- Cases Per Million Column -->
    <ng-container matColumnDef="details-icon">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="rowHovered">arrow_forward_ios</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['country/' + row.country]"></tr>
  </table>
</div>
